import { Component, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EffButtonComponent } from "../../eff-button/eff-button.component";
import { EffPopupHeaderComponent } from "../eff-popup-header/eff-popup-header.component";
import { EffTextareaFieldComponent } from "../../eff-textarea/eff-textarea-field.component";

@Component({
    selector: "eff-comment-popup",
    templateUrl: "./eff-comment-popup.component.html",
    styleUrls: ["./eff-comment-popup.component.scss"],
    imports: [EffButtonComponent, EffPopupHeaderComponent, EffTextareaFieldComponent]
})
export class EffCommentPopupComponent {
    data = inject(MAT_DIALOG_DATA);
    dialogRef = inject<MatDialogRef<EffCommentPopupComponent>>(MatDialogRef);


    confirm() {
        this.data.confirm(this.data.text);
        this.dialogRef.close();
    }
    cancel() {
        this.dialogRef.close();
    }
}
